module.exports = __webpack_public_path__ + "b7e03fb482787fca176ff03ae9f6cc16.pdf";